import { MONTHS } from "./months";

export const parseTime = (time) => {
  const [month, year] = time.split("/").map((v) => Number(v));

  const monthText = MONTHS[month - 1].slice(0, 3);

  return `${monthText}/${year}`;
};
